<template>
  <div class="swiper-box">
    <!-- {{swipeList}} -->
    <van-swipe
      indicator-color="white"
      :autoplay="3000"
      class="banner-swiper-mode3"
    >
      <van-swipe-item
        v-for="(item, index) in swipeList"
        :key="index"
        loading="loading"
        @click="openUrl(item)"
      >
        <img v-lazy="item.image" style="width: 100%" alt="" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
// swipeList
export default {
  props: {
    swipeList: {
      type: [Object, Array],
      required: []
    }
  },
  methods: {
    openUrl(e) {
      // if(e.jump_url && e.jump_url!='#'){
      // 	window.open(e.jump_url)
      // }
      if (e.jump_url && e.jump_url != '#') {
        if (/^http/.test(e.jump_url)) {
          window.open(e.jump_url, '_blank');
          return false;
        }
        this.$router.push({ name: e.jump_url });
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.banner-swiper-mode3 {
  overflow: hidden;
}
:deep(.van-swipe__indicators) {
  display: none !important;
}
</style>
